import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

export interface InlineRowProps {
  label: string;
  children: ReactNode;
  className?: string;
}

export function InlineRow({ label, children, className }: InlineRowProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-between py-1.5 text-[11.5px]',
        'border-b border-borderSoft',
        className
      )}
    >
      <span className="text-textMute">{label}</span>
      <div>{children}</div>
    </div>
  );
}

InlineRow.displayName = 'InlineRow';

export default InlineRow;
